/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

interface AnnualReviewFeedbackChartProps {
  pendingReviewCount: number | undefined;
  completedReviewCount: number | undefined;
  totalReviews: number | undefined;
  pendingReviewList: string[] | undefined;
  completedReviewList: string[] | undefined;
}

const AnnualReviewFeedbackChart = ({
  pendingReviewCount,
  completedReviewCount,
  totalReviews,
  pendingReviewList,
  completedReviewList,
}: AnnualReviewFeedbackChartProps) => {
  const data = {
    labels: [
      `Pending Reviews ${pendingReviewCount ? (pendingReviewCount > 0 ? pendingReviewCount.toString().padStart(1, ' ') : '0') : 0}`,
      `Completed Reviews ${completedReviewCount ? (completedReviewCount > 0 ? completedReviewCount.toString().padStart(1, ' ') : '0') : 0}`,
    ],
    datasets: [
      {
        data: [pendingReviewCount, completedReviewCount],
        backgroundColor: ['rgba(98, 178, 253, 1)', 'rgba(155, 223, 196, 1)'],
        borderColor: ['rgba(98, 178, 253, 1)', 'rgba(155, 223, 196, 1)'],
        borderWidth: 1,
        mentees: [pendingReviewList, completedReviewList],
      },
    ],
  };

  const options: any = {
    cutout: '68%',
    responsive: true,
    maintainAspectRation: false,
    plugins: {
      legend: {
        display: totalReviews ? totalReviews >= 0 : 0,
        position: 'right',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          pointRadius: 0.4,
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        enabled: true,
        displayColors: false,
        callbacks: {
          title: function () {
            return '';
          },
          label: function (context: any) {
            const mentees = context.dataset.mentees[context.dataIndex];
            return mentees;
          },
          labelTextColor: function () {
            return 'rgba(97, 97, 97, 1)';
          },
          afterBody: (context: any) => {
            const backgroundColor = 'white';
            context[0].chart.tooltip.options.backgroundColor = backgroundColor;
          },
        },
      },
      datalabels: {
        display: false,
      },
      customPluginOptions: {
        totalReviews: totalReviews,
      },
    },
    layout: {
      padding: 5,
    },
  };

  const plugins: any = [
    {
      id: 'centerText',
      beforeDraw: function (chart: {
        ctx: any;
        chartArea: { right: number; left: number; top: any; bottom: any };
        config: {
          options: { plugins: { customPluginOptions: { totalReviews: any } } };
        };
      }) {
        const ctx = chart.ctx;

        ctx.restore();

        const innerRadius =
          (chart.chartArea.right - chart.chartArea.left) * 0.32;

        const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
        const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

        const total =
          chart?.config?.options?.plugins?.customPluginOptions.totalReviews;

        if (total && total >= 0) {
          const totalFontSize = innerRadius / 3;
          const numberFontSize = innerRadius / 4;

          ctx.font = `bold ${totalFontSize}px sans-serif`;
          ctx.textBaseline = 'bottom';
          ctx.textAlign = 'center';
          ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';

          const totalText = 'Reviews';

          ctx.fillText(totalText, centerX, centerY);

          ctx.font = `${numberFontSize}px sans-serif`;
          ctx.textBaseline = 'top';

          ctx.fillText(`${total}`, centerX, centerY + totalFontSize / 2);
        }

        ctx.save();
      },
    },
  ];

  return (
    <div className="flex justify-center items-center w-full h-full">
      <div className="w-[500px] h-[400px] relative">
        <Doughnut
          data={data}
          options={options}
          plugins={plugins}
          className="w-full h-full"
        />
      </div>
    </div>
  );
};

export default AnnualReviewFeedbackChart;
